jQuery(document).ready(function ($) {
    try {
        console.log("Events App Initialized");

        /* ------------------------------------------------------------
         * Global Namespace
         * ------------------------------------------------------------ */
        window.KK = {
            init: function () {
                this.emptyParagraph();
                this.closeBanner();
                this.restorePhotos();
                this.sidebarInfobox();
            },

            emptyParagraph: function () {
                const paragraphs = document.querySelectorAll('p');
                let removedCount = 0;

                paragraphs.forEach(p => {
                    const content = p.innerHTML.replace(/&nbsp;/g, '').trim();
                    if (content === '' && !p.hasChildNodes()) {
                        p.remove();
                        removedCount++;
                    }
                });

                if (removedCount > 0) {
                    console.log(`GhostHunter: ${removedCount} empty <p>`);
                }
            },

            closeBanner: function () {
                const banner = document.querySelector('.header-top');

                if (!banner) return;

                if (sessionStorage.getItem('algo_top_banner_closed') === 'true') {
                    banner.style.display = 'none';
                    return;
                }
                const closeBtn = document.createElement('button');
                closeBtn.innerHTML = '&times;';
                closeBtn.className = 'algo-banner-close';
                closeBtn.setAttribute('aria-label', 'Close banner');
                banner.appendChild(closeBtn);

                closeBtn.addEventListener('click', function (e) {
                    e.preventDefault();

                    jQuery(banner).slideUp(250, function () {
                        sessionStorage.setItem('algo_top_banner_closed', 'true');
                    });
                });
            },

            restorePhotos: function () {
                const lazyCards = document.querySelectorAll('.card.company[data-bg]');

                lazyCards.forEach(card => {
                    const bgUrl = card.getAttribute('data-bg');
                    const inlineStyle = card.getAttribute('style');

                    // Check if the background image was NOT injected by the primary lazy load script
                    if (bgUrl && (!inlineStyle || !inlineStyle.includes('background-image'))) {
                        // Forcefully apply the background image
                        card.style.backgroundImage = `url("${bgUrl}")`;

                        // Add status classes to ensure consistent CSS behavior
                        card.classList.add('entered', 'loaded');
                    }
                });
            },

            sidebarInfobox: function () {
                const initInfobox = () => {
                    const storageKey = 'sidebarInfoboxClosedTimestamp';
                    const closedTimestamp = localStorage.getItem(storageKey);

                    const now = Date.now();
                    const hours24 = 24 * 60 * 60 * 1000;

                    localStorage.removeItem('sidebarInfoboxClosed');

                    if (!closedTimestamp || (now - parseInt(closedTimestamp, 10)) > hours24) {
                        const infobox = document.getElementById('custom-sidebar-infobox');
                        const closeBtn = document.getElementById('close-infobox');

                        if (infobox && closeBtn) {
                            setTimeout(() => {
                                infobox.classList.add('is-visible');
                            }, 300);

                            closeBtn.addEventListener('click', () => {
                                infobox.classList.remove('is-visible');
                                localStorage.setItem(storageKey, Date.now().toString());
                            });
                        }
                    }
                };

                if (document.readyState === 'loading') {
                    document.addEventListener('DOMContentLoaded', initInfobox);
                } else {
                    initInfobox();
                }
            }
        };

        /* ------------------------------------------------------------
         * Initialize All Modules
         * ------------------------------------------------------------ */
        KK.init();
    } catch (err) {
        console.error("Events App error:", err);
    }
});